<!-- 作业分析-作业反馈异常 -->
<template>
	<div>
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>
<script>
	export default {
		name: "Index",
		data() {
			return {};
		},
		created() {},
		methods: {},
	};
</script>
